import { render } from "./AuthorizationList.vue?vue&type=template&id=6009fa1a&scoped=true"
import script from "./AuthorizationList.js?vue&type=script&lang=js&external"
export * from "./AuthorizationList.js?vue&type=script&lang=js&external"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AuthorizationList.scss?vue&type=style&index=1&id=6009fa1a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6009fa1a"]])

export default __exports__